import { Component, OnInit, Input, Output, forwardRef, EventEmitter, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, FormGroup } from '@angular/forms';
import { BaseControl } from '../../../models/base-control';
import { DateTimePikerTypes } from '../date-box/date-box.component';

//* FABRIC VARIABLE (necesaria para inicializar elementos de FABRIC UI en typeScript)
declare var fabric: any;

@Component({
  selector: 'app-date-box-r',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateBoxRComponent),
      multi: true
    }
  ],
  templateUrl: './date-box-r.component.html',
  styleUrls: ['./date-box-r.component.scss']
})

export class DateBoxRComponent extends BaseControl implements OnInit, AfterViewInit, ControlValueAccessor {

  @Input() dateTimePikerType: DateTimePikerTypes = DateTimePikerTypes.DateTime;
  @Input() format: string = 'DD/MM/YYYY HH:mm';
  @Input() lang: string = 'es';
  @Input() weekStart: number = 1;
  @Input() cancelText: string = 'Cancelar';
  @Input() okText: string;
  @Input() clearText: string = 'Limpiar';
  @Input() minDate: any;
  @Input() maxDate: any;

  //* FUNCIONES ANGULAR

  ngAfterViewInit() {

    if (this.isReactive && this.frm && this.config && this.frm.controls[this.config.Name]) {
      this.ctr = this.frm.controls[this.config.Name];
      this.ctr.valueChanges.subscribe(value => {

        this.value = value;
      })
    }

    (<any>$('#' + this.controlName)).change((e) => {
      // this.value =e.target.value;
      // this.ctr.setValue( this.value);
    });

    // (<any>$('#' + this.controlName)).datepicker({
    //   showOtherMonths: true,
    //   selectOtherMonths: true
    // });

    // (<any>$('#' + this.controlName)).datepicker();
    const that = this;
    var DatePickerElement = (<any>$("#DatePicker_" + this.controlName));
    this.config.FabricElement = new fabric['DatePicker'](DatePickerElement,
      {
        onSet: (thingSet) => {
          this.modelo = this.config.FabricElement.picker.get('select', ' dd/mm/yyyy');
          this.ctr.setValue(this.config.FabricElement.picker.get('select', ' dd/mm/yyyy'));
        },
        min: this.config.MinDate ? eval(this.config.MinDate) : undefined,
        max: this.config.MaxDate ? eval(this.config.MaxDate) : undefined
      });
    var distanceR = $(window).width() - (DatePickerElement.offset().left + DatePickerElement.width());
    if (distanceR <= 100) {
      $('#' + this.controlName + '_root').children('.ms-DatePicker-holder').css('right', '0');
    }

    // this.config.FabricElement = new fabric['DatePicker'](DatePickerElement,
    //   {
    //     onSet: (thingSet) => {

    //       //this.modelo =this.config.FabricElement.picker.get('select', ' dd/mm/yyyy');
    //       //  this.ctr.setValue(this.config.FabricElement.picker.get('select', ' dd/mm/yyyy'));
    //     }
    //   });

    // this.config.FabricElement.picker.trigger(event => {
    //   debugger;
    // })

    // this.config.FabricElement.picker.component.settings.onSet= function(thingSet) {
    //   console.log('Set stuff:', thingSet)
    //   alert(thingSet);
    // }
    // if (this.isReactive && this.frm && this.config && this.frm.controls[this.config.Name]) {
    //   this.ctr = this.frm.controls[this.config.Name];
    //   this.ctr.valueChanges.subscribe(value => {

    //     debugger;
    //     this.value = value;
    //     this.config.FabricElement.picker.set('select', value);
    //   })
    // }

  }

  //* END FUNCIONES ANGULAR



  InternalChanges(event) {

    console.log(event);
    alert("Handler for .InternalChanges() called.");
    this.value = event.target.value;
    //console.log('updateChanges ' + this.controlName)

  }

  setFechas() {

    this.config.FabricElement.picker.set('11', '11', '12');
    var d = new Date();
    var n = d.getDate();
    this.config.FabricElement.picker.set('select', '11-11-2020');

  }

  getFechas() {

    const that = this;
    let select = this.config.FabricElement.picker.get('select', ' dd/mm/yyyy');
    let valor = this.config.FabricElement.picker.get();
    alert(select);

  }

  //* END FUNCIONES PERSONALIZADAS

}